import { render, staticRenderFns } from "./AdminBreadcrumbs.vue?vue&type=template&id=499eaee8"
import script from "./AdminBreadcrumbs.vue?vue&type=script&lang=js"
export * from "./AdminBreadcrumbs.vue?vue&type=script&lang=js"
import style0 from "./AdminBreadcrumbs.vue?vue&type=style&index=0&id=499eaee8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports